import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { ClipboardCheck, Shield } from "lucide-react";
import { useIsAdmin } from "@/lib/hooks/useIsAdmin";
import { trpc } from "@/router";
import { AddPlaceCard } from "./AddPlaceCard";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function AdminDashboard() {
  const $ = _c(14);
  const isAdmin = useIsAdmin();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = trpc.features.getPendingCount.queryOptions();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== isAdmin) {
    t1 = {
      ...t0,
      enabled: isAdmin
    };
    $[1] = isAdmin;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: pendingCount
  } = useQuery(t1);
  if (!isAdmin) {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = /*#__PURE__*/_jsx("div", {
        className: "container mx-auto flex min-h-[60vh] items-center justify-center px-4",
        children: /*#__PURE__*/_jsx("p", {
          className: "text-gray-500",
          children: "Du har inte beh\xF6righet."
        })
      });
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = /*#__PURE__*/_jsxs("div", {
      className: "mb-6 flex items-center gap-3",
      children: [/*#__PURE__*/_jsx(Shield, {
        className: "text-brand h-7 w-7"
      }), /*#__PURE__*/_jsx("h1", {
        className: "text-2xl font-bold",
        children: "Admin"
      })]
    });
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = /*#__PURE__*/_jsx(ClipboardCheck, {
      className: "h-6 w-6 text-gray-400 group-hover:text-brand"
    });
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = /*#__PURE__*/_jsxs("div", {
      className: "flex-1",
      children: [/*#__PURE__*/_jsx("h2", {
        className: "font-semibold text-gray-900",
        children: "Granska"
      }), /*#__PURE__*/_jsx("p", {
        className: "text-sm text-gray-500",
        children: "Granska inskickade bidrag"
      })]
    });
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== pendingCount) {
    t5 = pendingCount != null && Number(pendingCount) > 0 && /*#__PURE__*/_jsx("span", {
      className: "flex h-6 min-w-6 items-center justify-center rounded-full bg-red-500 px-1.5 text-xs font-bold text-white",
      children: Number(pendingCount)
    });
    $[7] = pendingCount;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = /*#__PURE__*/_jsx(Link, {
      to: "/admin/granska",
      className: "group rounded-lg border p-5 transition-colors hover:border-brand/30 hover:bg-brand/5",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex items-center gap-3",
        children: [t3, t4, t5]
      })
    });
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = /*#__PURE__*/_jsx(AddPlaceCard, {});
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6) {
    t8 = /*#__PURE__*/_jsxs("div", {
      className: "mx-auto max-w-2xl px-4 py-8",
      children: [t2, /*#__PURE__*/_jsxs("div", {
        className: "grid gap-4",
        children: [t6, t7]
      })]
    });
    $[12] = t6;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}